import { ActivityReducers } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { addDataHolderReducer } from "./addDataHolderReducer";
import { removeDataHolderReducer } from "./removeDataHolderReducer";

export const customDataReducers: readonly ActivityReducers.DataReducer[] = [
	addDataHolderReducer,
	removeDataHolderReducer
];
